import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

const getPurchaseAccountPath = user => {
  const { accounts = [], account_id: currentAccountId = null } = user || {};
  const administratorAccounts = accounts.filter(
    account => account.role === 'administrator'
  );
  const selected =
    administratorAccounts.find(
      account => Number(account.id) === Number(currentAccountId)
    ) || administratorAccounts[0];
  return selected ? `accounts/${selected.id}` : '';
};

const capitalize = str =>
  str
    .split(/[._-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getCredentialsFromEmail = email => {
  const [localPart, domain] = email.split('@');
  const namePart = localPart.split('+')[0];
  return {
    fullName: capitalize(namePart),
    accountName: capitalize(domain.split('.')[0]),
  };
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
  purchasePlan,
  purchaseDuration,
  purchasePromotion,
}) => {
  const accountPath = purchasePlan
    ? getPurchaseAccountPath(user)
    : getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    if (purchasePlan) {
      const query = new URLSearchParams({ plan: purchasePlan });
      if (purchaseDuration) query.set('duration', purchaseDuration);
      if (purchasePromotion) query.set('promotion', purchasePromotion);
      return frontendURL(`${accountPath}/settings/billing?${query.toString()}`);
    }
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
